/**
 * micro:bit 놀이터 3D 무대(2026-10-08 — 스마트브릭 기구 무대와 같은 무대 · 손님 · 별) — 장면마다 쓸 무대 장면(렌더러 STAGE_THEMES)과
 * 3D 보기 켜기 · 끄기(이 기기에 기억). 판정은 그대로 lib/* 의 장면 상태다(이 파일은 모습만).
 */
import type { SceneId } from "./scenes";

/** 장면 → 무대 장면 키(분위기가 맞는 것 · 없으면 운동장) */
export const MB_SCENE_THEME: Readonly<Record<SceneId, string>> = {
  stars: "playground-sand",
  greet: "forest-post",
  story: "art-studio",
  harbor: "pirate-sea",
  gate: "amusement-day",
  boardGame: "toy-workshop",
  nameTag: "art-studio",
  gallery: "art-studio",
  movie: "art-studio",
  marquee: "amusement-day",
  heartbeat: "sports-day",
  faceCourse: "sports-day",
  goals: "sports-day",
  rps: "toy-workshop",
  reaction: "toy-workshop",
  quiz: "forest-concert",
  dice: "toy-workshop",
  ballMaze: "toy-workshop",
  track: "sports-day",
  level: "toy-workshop",
  plaza: "playground-sand",
  aiCards: "art-studio",
  firefly: "forest-nest",
  nightWalk: "sunset-sky",
  fridge: "cake-shop",
  seasons: "forest-post",
  thermoRooms: "toy-workshop",
  magicForest: "forest-nest",
  clapLamp: "forest-concert",
  library: "art-studio",
  compassField: "mountain-heli",
  maze: "playground-sand",
  balance: "amusement-day",
  marathon: "sports-day",
  door: "forest-post",
  watch: "sunset-sky",
  cheer: "forest-concert",
  showcase: "art-studio",
  melody: "forest-concert",
  band: "forest-concert",
  hotCold: "playground-sand",
  bungee: "drop-tower",
  treasureIsland: "pirate-sea",
  magnetRock: "dino-museum",
  sunDial: "sunset-sky",
  quizShow: "forest-concert",
  classroom: "toy-workshop",
  morningRoom: "sunset-sky",
  dayLogger: "playground-sand",
};

export const themeOfScene = (id: SceneId): string => MB_SCENE_THEME[id] ?? "playground-sand";

/** 운영 카탈로그 키(영문 소문자 · 숫자 · - 만 — faceCourse → face-course) — 별 기준(mb_goal)은 이 키 · 무대 꾸밈(stage_scene)은 'mb-' + 이 키 */
export const mbKey = (id: SceneId): string => id.replace(/[A-Z]/g, (m) => `-${m.toLowerCase()}`);
export const mbDecorKey = (id: SceneId): string => `mb-${mbKey(id)}`;

const KEY = "pf.mb.stage3d";
/** 3D 무대를 켤까(기본 켬 — 이 기기에서 끈 적이 있으면 끔 · 저장소가 막혀 있으면 기본) */
export function readStage3d(): boolean {
  try {
    return window.localStorage.getItem(KEY) !== "0";
  } catch {
    return true;
  }
}
export function writeStage3d(on: boolean): void {
  try {
    window.localStorage.setItem(KEY, on ? "1" : "0");
  } catch {
    /* 저장 못 해도 이번 화면은 그대로 */
  }
}
